"use client"

import { motion } from "framer-motion"
import { FaLinkedin, FaEnvelope } from "react-icons/fa"

const EquipoAbogados = ({ equipo }) => {
  console.log(equipo) 
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <h2 className="text-2xl font-bold">Nuestro Equipo</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {equipo.map((miembro, index) => (
          <motion.div
            key={miembro.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ y: -5 }}
            className="bg-white rounded-lg shadow-md overflow-hidden"
          >
            <div className="relative">
              <img
                src={miembro.image || "/placeholder.svg"}
                alt={miembro.nombre}
                className="w-full h-48 object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
                <h3 className="text-white text-lg font-semibold">{miembro.className}</h3>
                <p className="text-white text-sm opacity-90">{miembro.position}</p>
              </div>
            </div>

            <div className="p-4">
              <div className="mb-4">
                <p className="text-gray-600">
                  <span className="font-semibold">Especialidad:</span> {miembro.specialty}
                </p>
                <p className="text-gray-600">
                  <span className="font-semibold">Experiencia:</span> {miembro.experience}
                </p>
              </div>

              <div className="flex space-x-4">
                <button className="flex items-center space-x-2 text-[var(--gold)] hover:text-[var(--gold-dark)] ">
                  <FaLinkedin />
                  <span className="text-sm">LinkedIn</span>
                </button>
                <button className="flex items-center space-x-2 text-[var(--gold)] hover:text-[var(--gold-dark)] ">
                  <FaEnvelope />
                  <span className="text-sm">Contactar</span>
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  )
}

export default EquipoAbogados

